import React, { useEffect, useState } from "react";
import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router-dom";
import ErrorScreen, { reportStatusFrom } from "./ErrorScreen";
import { reportError } from "src/lib/errorReporter";
import { markErrorHandled } from "src/lib/globalErrors";

/* Fallback shown by the router when a page throws while rendering, instead of a blank screen */
const RouteError = ({ fullHeight = false }) => {
  const error = useRouteError();
  const navigate = useNavigate();
  const isResponse = isRouteErrorResponse(error);
  const notFound = isResponse && error.status === 404;
  const [report, setReport] = useState({ status: "sending", reportId: undefined });

  // Mark it right away so the global window "error" listener doesn't show it again as a modal
  markErrorHandled(error);

  useEffect(() => {
    if (notFound) return undefined;
    console.error("Route error:", error);
    let active = true;
    setReport({ status: "sending", reportId: undefined });

    const reportable = isResponse
      ? Object.assign(new Error(error.statusText || `HTTP ${error.status}`), { name: "RouteErrorResponse" })
      : error;
    reportError(reportable, { source: "router", status: isResponse ? error.status : undefined }).then(
      (result) => {
        if (active) setReport({ status: reportStatusFrom(result), reportId: result.reportId });
      }
    );
    return () => {
      active = false;
    };
  }, [error, isResponse, notFound]);

  return (
    <ErrorScreen
      fullHeight={fullHeight}
      error={error}
      notFound={notFound}
      reportStatus={report.status}
      reference={report.reportId || error?.requestId}
      onReload={() => navigate(0)}
      onHome={() => navigate("/index")}
    />
  );
};

export default RouteError;
